import React, { useState, useEffect, useRef } from "react";
import { getI18n } from "react-i18next";
import { useForm } from "react-hook-form";
import { API } from "../../env";
import swal from "sweetalert";
import { STATIC } from "../../env";
import CroppedImageModal from "../CroppedImageModal/index";
import CroppedImage from "../CroppedImage/index";
function AboutPage() {
  const _ = getI18n();
  const { register, handleSubmit, errors, reset, getValues } = useForm();
  const [data, setData] = useState({});
  const [file, setFile] = React.useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(null);
  const [imageToCrop, setImageToCrop] = useState(null);
  const [imgData, setImgData] = useState(null);
  const onChangePicture = (e) => {
    if (e.target.files[0]) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImgData(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };
  const handleChangeFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImageToCrop(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    }
    e.target.value = null;
  };
  const cropChangedHandler = (image) => {
    let reader = new FileReader();
    let file = image;

    reader.onloadend = () => {
      setFile(file);
      setImagePreviewUrl(reader.result);
      //setImageToCrop(null);
    };

    reader.readAsDataURL(file);
  };
  const fileChange = (e) => {
    handleChangeFile(e);
    window.$("#croppedImageModal").modal("show");
  };

  useEffect(() => {
    const fetchData = () => {
      fetch(API.content.load, {
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
          'x-site-id': JSON.parse(localStorage.getItem('currentSite'))._id,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: "ABOUT",
        }),
      })
        .then((res) => res.json())
        .then((response) => {
          console.log(response);
          setData(response);
        })
        .catch((e) => {});
    };
    fetchData();
  }, []);
  useEffect(() => {
    window.$(".filestyle").filestyle({
      buttonName: "btn-primary",
    });
  }, []);
  const onSubmit = (dataToSend) => {
    console.log(data);
    const formData = new FormData();
    formData.append("name", "ABOUT");

    if (file) {
      formData.append("files", file, "image");
    }
    if (getValues("image").length === 0) {
      if (data.image !== "") {
        dataToSend.image = data.image;
      } else {
        dataToSend.image = "";
      }
    }
    if (getValues("subHeaderImage").length > 0) {
      formData.append("files", dataToSend.subHeaderImage[0], "subHeaderImage");
    }
    if (getValues("subHeaderImage").length === 0) {
      if (data.subHeaderImage !== "") {
        dataToSend.subHeaderImage = data.subHeaderImage;
      } else {
        dataToSend.subHeaderImage = "";
      }
    }
    formData.append("content", JSON.stringify(dataToSend));

    fetch(API.content.update, {
      method: "POST",
      headers: {
        "x-auth-token": localStorage.getItem("token"),
        'x-site-id': JSON.parse(localStorage.getItem('currentSite'))._id,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.error) {
          return swal(_.t("ERROR"), response.message, "error");
        }
        return swal(_.t("SUCCESS"), _.t("DATA_UPDATED"), "success");
      })
      .catch((e) => swal(_.t("ERROR"), _.t("SERVER_ERR"), "error"));
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group row">
                  {imgData !== null ? (
                    <img
                      style={{
                        width: "600px",
                        height: "300px",
                        textAlign: "center",
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                      src={imgData}
                    />
                  ) : (
                    data.subHeaderImage && (
                      <img
                        style={{
                          width: "600px",
                          height: "300px",
                          textAlign: "center",
                          display: "block",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                        src={STATIC.ROUTE(data.subHeaderImage)}
                      />
                    )
                  )}
                </div>
                <div className="form-group row">
                  <label for="name" className="col-sm-2 col-form-label">
                    {_.t("SUB_HEADER_IMAGE")}
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="file"
                      className="filestyle"
                      name="subHeaderImage"
                      ref={register}
                      onChange={onChangePicture}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  {imagePreviewUrl === null ? (
                    data.image && (
                      <img
                        style={{
                          width: "600px",
                          height: "300px",
                          textAlign: "center",
                          display: "block",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                        src={STATIC.ROUTE(data.image)}
                      />
                    )
                  ) : (
                    //<img src={images.accountProfile} alt="profile" />
                    <img src={imagePreviewUrl} />
                  )}
                  {}
                </div>
                <CroppedImageModal
                  fileChangedHandler={cropChangedHandler}
                  file={file}
                >
                  <CroppedImage src={imageToCrop} setFile={setFile} />
                </CroppedImageModal>
                <div className="form-group row">
                  <label for="name" className="col-sm-2 col-form-label">
                    {_.t("IMAGE")}
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="file"
                      className="filestyle"
                      name="image"
                      ref={register}
                      onChange={(e) => {
                        fileChange(e);
                      }}
                      //onChange={(e) => {
                      // handleChangeFile(e);
                      // handleModal();
                      //}}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label">
                    {_.t("TITLE")}*
                  </label>
                  <div className="col-sm-10">
                    <input
                      className="form-control"
                      type="text"
                      placeholder={_.t("TITLE_PH")}
                      ref={register({ required: true })}
                      name="title"
                      defaultValue={data.title ? data.title : ""}
                    />
                    {errors.title && (
                      <span className="text-danger">
                        {`${_.t("TITLE")} ${_.t("RQUIRED_FIELD")}`}
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label">
                    {_.t("SUB_TITLE")}*
                  </label>
                  <div className="col-sm-10">
                    <input
                      className="form-control"
                      type="text"
                      placeholder={_.t("SUB_TITLE_PH")}
                      ref={register({ required: true })}
                      name="subTitle"
                      defaultValue={data.subTitle ? data.subTitle : ""}
                    />
                    {errors.title && (
                      <span className="text-danger">
                        {`${_.t("SUB_TITLE")} ${_.t("RQUIRED_FIELD")}`}
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label">
                    {_.t("DESCRIPTION")}*
                  </label>
                  <div className="col-sm-10">
                    <textarea
                      className="form-control"
                      type="text"
                      placeholder={_.t("DESCRIPTION_PH")}
                      ref={register({ required: true })}
                      name="description"
                      defaultValue={data.description ? data.description : ""}
                    />
                    {errors.title && (
                      <span className="text-danger">
                        {`${_.t("DESCRIPTION")} ${_.t("RQUIRED_FIELD")}`}
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label">
                    {_.t("CONTENT_BUTTON")}*
                  </label>
                  <div className="col-sm-10">
                    <input
                      className="form-control"
                      type="text"
                      placeholder={_.t("CONTENT_BUTTON_PH")}
                      ref={register({ required: true })}
                      name="buttonText"
                      defaultValue={data.buttonText ? data.buttonText : ""}
                    />
                    {errors.title && (
                      <span className="text-danger">
                        {`${_.t("CONTENT_BUTTON")} ${_.t("RQUIRED_FIELD")}`}
                      </span>
                    )}
                  </div>
                </div>

                <div className="form-group mb-0" style={{ float: "right" }}>
                  <div>
                    <button
                      type="reset"
                      className="btn btn-secondary waves-effect  mr-1"
                      onClick={(e) => reset(e.target)}
                    >
                      {_.t("RESET")}
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary waves-effect waves-light mr-1"
                    >
                      {_.t("SUBMIT")}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AboutPage;
